import React from 'react';
import { Modal, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import { InfoNews } from './NewsView';
import { SingleWindow } from '../../../../store/Window';
import {
  INewsCategories,
  INewsItemProperties,
} from '../../../../store/News/types';

const { Title } = Typography;

interface NewsCardModalProps {
  card: SingleWindow<INewsItemProperties>;
  categoriesLoader: INewsCategories;
}

export const NewsCardModal: React.FC<NewsCardModalProps> = observer(
  ({ card, categoriesLoader }) => {
    if (!card.window?.visible) return <></>;

    const {
      description,
      photos,
      date_end,
      date_start,
      category,
      address,
      link,
    } = card.window.data;

    return (
      <Modal
        width={900}
        open={card.window.visible}
        title={
          <Title style={{ paddingRight: 12 }} level={5}>
            {card.window.data.title}
          </Title>
        }
        onCancel={card.close}
        footer={<div></div>}
        classNames={{ container: 'card-view-modal' }}
        styles={{
          body: { height: 600, padding: 0, overflow: 'hidden auto' },
        }}
      >
        <InfoNews
          categories={categoriesLoader}
          description={description}
          link={link}
          photos={photos}
          dateEnd={date_end}
          dateStart={date_start}
          categoryId={category}
          address={address}
        />
      </Modal>
    );
  },
);
